import type { ResultAsync } from "neverthrow";

export type { Result } from "neverthrow";
export { err, errAsync, ok, okAsync, ResultAsync } from "neverthrow";

export function unwrapResultAsync<TValue, TError>(
  result: ResultAsync<TValue, TError>,
): Promise<TValue> {
  return result.match(
    (value) => value,
    (error) => {
      throw error;
    },
  );
}

export function getUnknownErrorMessage(error: unknown): string {
  try {
    if (error instanceof Error) {
      return error.message;
    }

    if (typeof error === "string") {
      return error;
    }

    // JSON.stringify 的类型签名忽略了它对 undefined、函数、symbol 会返回 undefined。
    const serialized: unknown = JSON.stringify(error);

    if (typeof serialized === "string") {
      return serialized;
    }
  } catch {
    // 继续尝试不会向调用方抛错的最终字符串转换。
  }

  try {
    return String(error);
  } catch {
    return "无法读取错误信息";
  }
}
